export enum LOADING_STATUS {
  LOADING = "loading",
  FAILED = "failed",
  IDLE = "idle",
}

export enum ROLES {
  OwnerMaintainerApplication = "OwnerMaintainerApplication",
  Owner = "Owner",
  Cleaner = "Cleaner",
  TechnicalMaintainer = "TechnicalMaintainer",
  KeyMaintainer = "KeyMaintainer",
  LinenMaintainer = "LinenMaintainer",
}

export enum CLAIM_TYPES {
  RolesType = "roles",
}

export const TOAST_SHOW_DURATION = 5000;

export const TOAST_EXPIRATION = 4000;
